export default __webpack_public_path__ + "static/media/Industrial-Steel-Structure-Mezzanine-Platform-System-Mezzanine-Floor.ab7bd770.jpg";